export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_03.a17c1adf.png";